import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import NoteItem from './NoteItem';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const ListContainer = /*#__PURE__*/_styled("div", {
  target: "etcnkr60",
  label: "ListContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1yrfwjn",
  styles: "flex:1;overflow-y:auto;padding:8px 30px"
} : {
  name: "1yrfwjn",
  styles: "flex:1;overflow-y:auto;padding:8px 30px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function NotesList({
  notes,
  onUpdate,
  onDelete,
  onToggleResolution,
  user,
  t
}) {
  // Sort notes: unresolved first, then by newest
  const sortedNotes = notes.sort((a, b) => {
    // First sort by resolved status (unresolved first)
    if (a.get('resolved') !== b.get('resolved')) {
      return a.get('resolved') ? 1 : -1;
    }
    // Then sort by timestamp (newest first)
    return new Date(b.get('timestamp')) - new Date(a.get('timestamp'));
  });
  return _jsx(ListContainer, {
    children: sortedNotes.map(note => _jsx(NoteItem, {
      note: note,
      onUpdate: onUpdate,
      onDelete: onDelete,
      onToggleResolution: onToggleResolution,
      user: user,
      t: t
    }, note.get('id')))
  });
}
NotesList.propTypes = {
  notes: ImmutablePropTypes.list.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onToggleResolution: PropTypes.func.isRequired,
  user: PropTypes.object,
  t: PropTypes.func.isRequired
};
export default NotesList;